import React, { forwardRef, ImgHTMLAttributes, useEffect, useMemo, useState } from "react";
import noImage from "src/assets/images/noImage_default.svg";
import { getResizedImageUrl, getResizedSmallImageUrl } from "src/utils/common-util";

interface ResizedImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  // 추가하고 싶은 커스텀 props
  url?: string;
  className?: string;
  alt: string;
  width?: string;
  height?: string;
  onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  defaultImage?: string;
  noResize?: boolean;
  isUseSmallSize?: boolean;
}

/**
 * 이미지 원본 url 받아서 resized 이미지 먼저 보여주고,
 * 없을 경우 원본이미지 보여주는 컴포넌트
 */
const ResizedImage = forwardRef<HTMLImageElement, ResizedImageProps>(
  ({ url, className, alt, width, height, onError, defaultImage = noImage, noResize, isUseSmallSize, ...props }, ref) => {
    const getImageSrc = useMemo(() => {
      if (noResize) {
        return url;
      } else if (isUseSmallSize) {
        return getResizedSmallImageUrl(url);
      } else {
        return getResizedImageUrl(url);
      }
    }, [url, noResize, isUseSmallSize]);

    return (
      <img
        ref={ref}
        {...props}
        className={className}
        src={getImageSrc || defaultImage}
        alt={alt || "이미지를 불러오는데 실패했습니다."}
        width={width}
        height={height}
        onError={(e) => {
          if (onError) {
            onError(e);
            return;
          }
          const currentSrc = e.currentTarget.src;
          if (currentSrc.includes("_resized_small")) {
            e.currentTarget.src = getResizedImageUrl(url);
          } else if (currentSrc.includes("_resized")) {
            e.currentTarget.src = url || defaultImage;
          } else {
            e.currentTarget.src = defaultImage;
          }
        }}
      />
    );
  },
);

// 개발 환경에서 컴포넌트 이름 표시를 위한 설정
ResizedImage.displayName = "ResizedImage";

export default ResizedImage;
